import { render, staticRenderFns } from "./miniprogramLink.vue?vue&type=template&id=8ec6c244"
import script from "./miniprogramLink.vue?vue&type=script&lang=js"
export * from "./miniprogramLink.vue?vue&type=script&lang=js"
import style0 from "./miniprogramLink.vue?vue&type=style&index=0&id=8ec6c244&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports